function Ctrl($rootScope, $scope, utilsService, authService, supportService, tlConfig, modalService) {
  $scope.init = function() {
    $scope.loading = false;
    $scope.intro = true;
    $scope.form = {};
    $scope.reasons = [
      'I want to book a table',
      'I want to buy a ticket',
      'Help me plan my night',
      'Technical issue',
      'Credit and billing matters',
      'Other'
    ];
    $scope.selectedReason = $scope.reasons[0];
    $scope.message = '';
    $scope.errorMessage = null;
  };

  $scope.begin = function() {
    $scope.intro = false;
  };

  $scope.signIn = function() {
    modalService.authUser(null, null, {
      startState: 'existingUser'
    });
  };

  $scope.selectReason = function(reason) {
    $scope.selectedReason = reason;
  };

  $scope.startTalking = function() {
    if (!$scope.form.firstName || !$scope.form.lastName) {
      $scope.errorMessage = 'First and last name are required';
      return;
    }

    if (!$scope.form.phone) {
      $scope.errorMessage = 'Phone is required';
      return;
    }

    if (!$scope.form.email) {
      $scope.errorMessage = 'Email is required';
      return;
    }

    if (!$scope.form.password) {
      $scope.errorMessage = 'Password is required';
      return;
    }

    if (!$scope.message) {
      $scope.errorMessage = 'Please type in a message';
      return;
    }

    if ($scope.loading) return;
    $scope.loading = true;

    tlConfig.setSubclient('www-concierge');

    authService.register($scope.form, function() {
      const text = `Reason: ${$scope.selectedReason}\n${$scope.message}`;
      const options = {};

      supportService.sendInboundMessage(text, options);

      $scope.init();
    }, function(err) {
      $scope.loading = false;
      if (err.data.errors && err.data.errors[0]) {
        $scope.errorMessage = err.data.errors[0].message;
      } else {
        $scope.errorMessage = 'Something went wrong. Please try again.';
      }
    });
  };

  $scope.init();
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  'utilsService',
  'tl.auth.service',
  'tl.support.service',
  'tl.config',
  'modalService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/conciergeSignup/controller.js